<div class="discount-form-page">
    <div class="btn-back-detail" (click)="cancel()">
        <i class="fal fa-arrow-left"></i>
        <span>Ver todos los descuentos</span>
    </div>

    <div *ngIf="!loaded" class="loading-container">
        <ng-lottie class="lottie" [options]="{path: 'assets/lotties/loading.json'}"
            containerClass="loading-box"></ng-lottie>
    </div>

    <form *ngIf="loaded" [formGroup]="form" (ngSubmit)="save()" class="form-layout">
        <!-- Left column: Form -->
        <div class="form-column">

            <!-- Section 1: Datos del descuento -->
            <div class="form-card">
                <div class="card-header">
                    <i class="fal fa-clipboard-list card-icon"></i>
                    <div>
                        <h2>Datos del descuento</h2>
                        <p class="card-subtitle">Nombre y tipo de la promoción</p>
                    </div>
                </div>
                <div class="form-grid-2">
                    <div class="form-field">
                        <label class="field-label">NOMBRE INTERNO</label>
                        <input type="text" formControlName="name" placeholder="Ej: Promo Verano 2024">
                        <span class="field-hint"><i class="fal fa-info-circle"></i> Solo visible internamente</span>
                    </div>
                    <div class="form-field">
                        <label class="field-label">NOMBRE PÚBLICO</label>
                        <input type="text" formControlName="public_name"
                            placeholder="Ej: ¡20% de Descuento en tu entrada!">
                        <span class="field-hint"><i class="fal fa-info-circle"></i> Opcional · Si se deja vacío, se usará el nombre interno</span>
                    </div>
                </div>
                <label class="field-label" style="margin-top: 20px;">TIPO DE PROMOCIÓN</label>
                <div class="type-cards">
                    <div class="type-card" [class.selected]="form.get('rule_type')?.value === 'promo_code'"
                        (click)="setRuleType('promo_code')">
                        <i class="fal fa-ticket-simple"></i>
                        <span class="type-card-title">Código</span>
                        <span class="type-card-desc">El cliente introduce un código</span>
                    </div>
                    <div class="type-card" [class.selected]="form.get('rule_type')?.value === 'volume'"
                        (click)="setRuleType('volume')">
                        <i class="fal fa-users"></i>
                        <span class="type-card-title">Volumen</span>
                        <span class="type-card-desc">Se aplica al comprar X o más</span>
                    </div>
                    <div class="type-card" [class.selected]="form.get('rule_type')?.value === 'bundle'"
                        (click)="setRuleType('bundle')">
                        <i class="fal fa-box-open"></i>
                        <span class="type-card-title">Pack</span>
                        <span class="type-card-desc">Compra X y paga solo Y</span>
                    </div>
                </div>

                <!-- Promo code fields (solo si es Código) -->
                <div class="promo-code-section" *ngIf="form.get('rule_type')?.value === 'promo_code'">
                    <div class="form-grid-2" style="margin-top: 16px;">
                        <div class="form-field">
                            <label class="field-label">CÓDIGO PROMOCIONAL</label>
                            <div class="input-with-action">
                                <input type="text" formControlName="promo_code_value" placeholder="Ej: VERANO24"
                                    style="text-transform: uppercase;">
                                <button type="button" class="btn-generate" (click)="generateCode()">GENERAR</button>
                            </div>
                        </div>
                        <div class="form-field">
                            <label class="field-label">LÍMITE DE USOS GLOBAL</label>
                            <div class="input-with-icon">
                                <i class="fal fa-globe"></i>
                                <input type="number" formControlName="max_uses_global" min="1"
                                    placeholder="Sin límite">
                            </div>
                            <span class="field-hint"><i class="fal fa-info-circle"></i> Opcional · Vacío = usos ilimitados</span>
                        </div>
                    </div>
                    <div class="form-grid-2" style="margin-top: 12px;">
                        <div class="form-field">
                            <label class="field-label">LÍMITE POR USUARIO</label>
                            <div class="input-with-icon">
                                <i class="fal fa-user"></i>
                                <input type="number" formControlName="max_uses_per_customer" min="1"
                                    placeholder="Sin límite">
                            </div>
                            <span class="field-hint"><i class="fal fa-info-circle"></i> Opcional · Vacío = sin límite por persona</span>
                        </div>
                    </div>
                </div>

            </div>

            <!-- Section: Alcance -->
            <div class="form-card">
                <div class="card-header">
                    <i class="fal fa-bullseye card-icon"></i>
                    <div>
                        <h2>Alcance</h2>
                        <p class="card-subtitle">Elige si el descuento se aplica a todos tus eventos o solo a algunos en concreto</p>
                    </div>
                </div>
                <div class="scope-toggle">
                    <button type="button" class="toggle-btn"
                        [class.active]="form.get('apply_scope')?.value === 'company'"
                        (click)="form.patchValue({apply_scope: 'company'})">
                        Todos los eventos
                    </button>
                    <button type="button" class="toggle-btn"
                        [class.active]="form.get('apply_scope')?.value === 'event'"
                        (click)="form.patchValue({apply_scope: 'event'})">
                        Eventos específicos
                    </button>
                </div>

                <!-- Cálculo por sesión (solo volume, bundle, pass) -->
                <div class="session-strict-block" *ngIf="['volume', 'bundle', 'pass'].includes(form.get('rule_type')?.value)">
                    <div class="session-strict-row">
                        <div class="session-strict-text">
                            <span class="session-strict-title">
                                <i class="fal fa-layer-group"></i>
                                {{ form.get('session_strict_mode')?.value
                                    ? 'Aplicar el descuento a cada sesión del evento por separado'
                                    : 'Aplicar el descuento al total de entradas del evento' }}
                            </span>
                            <span class="session-strict-desc" *ngIf="form.get('rule_type')?.value === 'volume'">
                                {{ form.get('session_strict_mode')?.value
                                    ? 'Cada sesión del evento debe alcanzar su propio mínimo de entradas para que se aplique el descuento.'
                                    : 'Se suman las entradas de todas las sesiones del evento para alcanzar el mínimo necesario.' }}
                            </span>
                            <span class="session-strict-desc" *ngIf="form.get('rule_type')?.value === 'bundle'">
                                {{ form.get('session_strict_mode')?.value
                                    ? 'Cada sesión del evento forma sus propios packs de forma independiente.'
                                    : 'Se combinan las entradas de todas las sesiones del evento para formar los packs.' }}
                            </span>
                            <span class="session-strict-desc" *ngIf="form.get('rule_type')?.value === 'pass'">
                                {{ form.get('session_strict_mode')?.value
                                    ? 'Cada sesión del evento cuenta por separado para el abono, aunque pertenezcan al mismo evento.'
                                    : 'Todas las sesiones de un mismo evento se agrupan y cuentan como una sola para el abono.' }}
                            </span>
                        </div>
                        <label class="toggle-switch">
                            <input type="checkbox" formControlName="session_strict_mode" (change)="onSessionStrictModeChange()">
                            <span class="toggle-slider"></span>
                        </label>
                    </div>
                </div>

                <!-- Event selector -->
                <div class="event-selector" *ngIf="form.get('apply_scope')?.value !== 'company'">
                    <label class="field-label" style="margin-top: 16px;">SELECCIONAR EVENTOS</label>

                    <!-- Chips simples (strict mode OFF) -->
                    <div class="event-chips" *ngIf="getSelectedEvents().length > 0 && !form.get('session_strict_mode')?.value">
                        <div class="event-chip" *ngFor="let event of getSelectedEvents()">
                            <img [src]="urlImages + event.image_url" [alt]="event.title" class="event-chip-img" *ngIf="event.image_url">
                            <span>{{ event.title }}</span>
                            <i class="fal fa-xmark" (click)="removeEvent(event.id)"></i>
                        </div>
                    </div>

                    <!-- Chips: una por sesión seleccionada (strict mode ON) -->
                    <div class="event-chips" *ngIf="getSelectedEvents().length > 0 && form.get('session_strict_mode')?.value">
                        <div class="event-chip" *ngFor="let pair of getSelectedEventSessionPairs()">
                            <img [src]="urlImages + pair.event.image_url" [alt]="pair.event.title" class="event-chip-img" *ngIf="pair.event.image_url">
                            <span>
                                {{ pair.event.title }}
                                <span class="event-chip-session"> · {{ pair.session.start_date | date:'dd MMM':'+0000' }}<span *ngIf="getSessionDisplayTime(pair.session)"> · {{ getSessionDisplayTime(pair.session) }}</span></span>
                            </span>
                            <i class="fal fa-xmark" (click)="removeSessionChip(pair.session.id, pair.event.id)"></i>
                        </div>
                    </div>

                    <div class="event-list-wrapper">
                        <div class="event-filters-row">
                            <div class="event-search-input">
                                <i class="fal fa-search"></i>
                                <input type="text" placeholder="Buscar..." [(ngModel)]="eventSearchTerm" [ngModelOptions]="{standalone: true}">
                            </div>
                            <div class="category-dropdown" (click)="categoryDropdownOpen = !categoryDropdownOpen">
                                <div class="category-dropdown-trigger">
                                    <i class="fa-thin" [ngClass]="getSelectedCategoryIcon()"></i>
                                    <span>{{ getSelectedCategoryName() }}</span>
                                    <i class="fal fa-chevron-down dropdown-arrow" [class.open]="categoryDropdownOpen"></i>
                                </div>
                                <div class="category-dropdown-menu" *ngIf="categoryDropdownOpen" (click)="$event.stopPropagation()">
                                    <div class="category-dropdown-item" [class.active]="eventCategoryFilter === null" (click)="selectCategory(null)">
                                        <i class="fa-thin fa-grid-2"></i>
                                        <span>Todas las categorías</span>
                                    </div>
                                    <div class="category-dropdown-item" *ngFor="let cat of eventCategories"
                                        [class.active]="eventCategoryFilter === cat.id"
                                        (click)="selectCategory(cat.id)">
                                        <i class="fa-thin {{ cat.icon }}"></i>
                                        <span>{{ cat.name }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="event-options-list">
                            <ng-container *ngFor="let event of getFilteredEvents()">
                                <label class="event-option"
                                    [class.selected]="isEventSelected(event.id)"
                                    (click)="toggleEvent(event.id)">
                                    <i class="fa-solid fa-circle-check select-icon" *ngIf="isEventSelected(event.id)"></i>
                                    <i class="fal fa-circle select-icon" *ngIf="!isEventSelected(event.id)"></i>
                                    <img [src]="urlImages + event.image_url" [alt]="event.title" class="event-thumb" *ngIf="event.image_url">
                                    <div class="event-thumb event-thumb--placeholder" *ngIf="!event.image_url">
                                        <i class="fal fa-image"></i>
                                    </div>
                                    <div class="event-option-info">
                                        <span class="event-option-title">{{ event.title }}</span>
                                        <div class="event-option-meta">
                                            <span *ngIf="getEventDateLabel(event)"><i class="fal fa-calendar"></i> {{ getEventDateLabel(event) }}</span>
                                            <span *ngIf="getEventDisplayTime(event)"><i class="fal fa-clock"></i> {{ getEventDisplayTime(event) }}</span>
                                            <span *ngIf="event.space?.name"><i class="fal fa-location-dot"></i> {{ event.space.name }}</span>
                                            <span *ngIf="!event.space?.name && event.address"><i class="fal fa-location-dot"></i> {{ event.address }}</span>
                                            <span *ngIf="event.category?.name" class="event-option-cat"><i class="fa-thin" [ngClass]="getCategoryIcon(event.category?.id)"></i> {{ event.category.name }}</span>
                                        </div>
                                    </div>
                                </label>

                                <!-- Sub-selector de sesiones (solo si session_strict_mode activo y evento seleccionado) -->
                                <div class="event-sessions-dropdown"
                                    *ngIf="isEventSelected(event.id) && form.get('session_strict_mode')?.value && getSessionsForEvent(event.id).length > 0">
                                    <div class="event-sessions-list">
                                        <label class="event-session-option"
                                            *ngFor="let session of getSessionsForEvent(event.id)"
                                            [class.selected]="isSessionSelected(session.id)"
                                            (click)="toggleSession(session.id, event.id)">
                                            <i class="fa-solid fa-circle-check select-icon"
                                                *ngIf="isSessionSelected(session.id)"></i>
                                            <i class="fal fa-circle select-icon"
                                                *ngIf="!isSessionSelected(session.id)"></i>
                                            <div class="event-session-info">
                                                <span class="event-session-date">
                                                    <i class="fal fa-calendar"></i>
                                                    {{ session.start_date | date:'EEE dd MMM yyyy' }}
                                                </span>
                                                <span class="event-session-time" *ngIf="getSessionDisplayTime(session)">
                                                    <i class="fal fa-clock"></i>
                                                    {{ getSessionDisplayTime(session) }}
                                                </span>
                                            </div>
                                        </label>
                                    </div>
                                </div>
                            </ng-container>
                            <p class="field-hint" *ngIf="getFilteredEvents().length === 0" style="text-align: center; padding: 12px 0;">
                                No se encontraron eventos
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Section 2: Beneficio y Lógica -->
            <div class="form-card">
                <div class="card-header">
                    <i class="fal fa-calculator card-icon"></i>
                    <div>
                        <h2>Valor del descuento</h2>
                        <p class="card-subtitle">Tipo de descuento y cantidad a aplicar</p>
                    </div>
                </div>

                <!-- bundle: solo buy/pay quantity -->
                <ng-container *ngIf="form.get('rule_type')?.value === 'bundle'">
                    <div class="form-grid-3">
                        <div class="form-field">
                            <label class="field-label">COMPRA (X)</label>
                            <input type="number" formControlName="buy_quantity" min="2" placeholder="Ej: 3">
                            <span class="field-hint"><i class="fal fa-info-circle"></i> Mínimo 2</span>
                        </div>
                        <div class="form-field">
                            <label class="field-label">PAGA (Y)</label>
                            <input type="number" formControlName="pay_quantity" min="1" placeholder="Ej: 2">
                            <span class="field-hint"><i class="fal fa-info-circle"></i> Debe ser menor que X</span>
                        </div>
                    </div>
                </ng-container>

                <!-- otros tipos: discount_mode y discount_value -->
                <ng-container *ngIf="form.get('rule_type')?.value !== 'bundle'">
                    <div class="toggle-buttons">
                        <button type="button" class="toggle-btn"
                            [class.active]="form.get('discount_mode')?.value === 'percentage'"
                            (click)="form.patchValue({discount_mode: 'percentage'})">
                            % Descuento
                        </button>
                        <button type="button" class="toggle-btn"
                            [class.active]="form.get('discount_mode')?.value === 'fixed'"
                            (click)="form.patchValue({discount_mode: 'fixed'})">
                            € Descuento
                        </button>
                    </div>
                    <div class="form-grid-3">
                        <div class="form-field">
                            <label class="field-label">VALOR DEL DESCUENTO</label>
                            <div class="input-with-suffix">
                                <input type="number" formControlName="discount_value" step="0.01" min="0">
                                <span class="suffix">{{ form.get('discount_mode')?.value === 'percentage' ? '%' : '€'
                                    }}</span>
                            </div>
                        </div>
                        <div class="form-field" *ngIf="form.get('discount_mode')?.value === 'percentage'">
                            <label class="field-label">DESCUENTO MÁXIMO (€)</label>
                            <div class="input-with-suffix">
                                <input type="number" formControlName="max_discount_amount" step="0.01" min="0"
                                    placeholder="Sin límite">
                                <span class="suffix">€</span>
                            </div>
                            <span class="field-hint"><i class="fal fa-info-circle"></i> Opcional · Vacío = sin tope de descuento</span>
                        </div>
                        <div class="form-field" *ngIf="form.get('rule_type')?.value === 'volume'">
                            <label class="field-label">CANTIDAD MÍNIMA</label>
                            <input type="number" formControlName="min_quantity" min="1" placeholder="Ej: 5">
                        </div>
                    </div>
                </ng-container>
            </div>

            <!-- Section 3: Vigencia -->
            <div class="form-card">
                <div class="card-header">
                    <i class="fal fa-calendar-range card-icon"></i>
                    <div>
                        <h2>¿Cuándo se puede usar?</h2>
                        <p class="card-subtitle">Define el periodo de validez del descuento</p>
                    </div>
                </div>
                <div class="form-grid-2">
                    <div class="form-field">
                        <label class="field-label">FECHA INICIO VALIDEZ</label>
                        <app-datetime-selector
                            [date]="startsAtDate"
                            [time]="startsAtTime"
                            placeholder="Fecha inicio validez"
                            (saveDate)="onStartsAtChange($event)">
                        </app-datetime-selector>
                    </div>
                    <div class="form-field">
                        <label class="field-label">FECHA FIN VALIDEZ</label>
                        <app-datetime-selector
                            [date]="endsAtDate"
                            [time]="endsAtTime"
                            placeholder="Fecha fin validez"
                            (saveDate)="onEndsAtChange($event)">
                        </app-datetime-selector>
                    </div>
                </div>
                <p class="field-hint" style="margin-top: 8px;"><i class="fal fa-info-circle"></i> Opcional · Si no defines fechas, el descuento estará activo de forma indefinida.</p>
            </div>

            <!-- Section 4: Condiciones de Usuario (comentado - application_target se envía como null) -->
            <!-- TODO: Descomentar cuando se implemente la lógica de application_target en backend
            <div class="form-card">
                <div class="card-header">
                    <i class="fal fa-user-check card-icon"></i>
                    <h2>¿A quién se aplica?</h2>
                </div>
                <div class="radio-options">
                    <label class="radio-option" [class.selected]="form.get('application_target')?.value === null">
                        <input type="radio" formControlName="application_target" [value]="null">
                        <span>Todos los usuarios</span>
                    </label>
                    <label class="radio-option"
                        [class.selected]="form.get('application_target')?.value === 'each_ticket'">
                        <input type="radio" formControlName="application_target" value="each_ticket">
                        <span>Por cada ticket</span>
                    </label>
                    <label class="radio-option"
                        [class.selected]="form.get('application_target')?.value === 'condition_block'">
                        <input type="radio" formControlName="application_target" value="condition_block">
                        <span>Bloque de condición</span>
                    </label>
                </div>
            </div>
            -->

            <!-- Section 5: Canales de Venta -->
            <div class="form-card">
                <div class="card-header">
                    <i class="fal fa-store card-icon"></i>
                    <div>
                        <h2>¿Dónde se aplica?</h2>
                        <p class="card-subtitle">Elige en qué canales de venta estará disponible</p>
                    </div>
                </div>
                <div class="d-flex align-items-center justify-content-between channel-toggle-row">
                    <div>
                        <span class="channel-toggle-label">Todos los canales</span>
                        <span class="field-hint"><i class="fal fa-info-circle"></i> El descuento se aplica en todos los canales de venta</span>
                    </div>
                    <mat-slide-toggle color="primary"
                        [checked]="allChannelsEnabled"
                        (change)="toggleAllChannels($event.checked)">
                    </mat-slide-toggle>
                </div>
                <div class="channel-cards" *ngIf="!allChannelsEnabled" @fadeIn>
                    <!-- Web -->
                    <div class="channel-card" [class.selected]="isChannelSelected(1)" (click)="toggleChannel(1)">
                        <i class="fal fa-globe"></i>
                        <span>Web</span>
                        <i class="fa-solid fa-circle-check check-icon" *ngIf="isChannelSelected(1)"></i>
                    </div>
                    <!-- Taquilla (TPV + Cash) -->
                    <div class="channel-card" [class.selected]="isChannelSelected(2) && isChannelSelected(3)" (click)="toggleTaquilla()">
                        <i class="fal fa-cash-register"></i>
                        <span>Taquilla</span>
                        <i class="fa-solid fa-circle-check check-icon" *ngIf="isChannelSelected(2) && isChannelSelected(3)"></i>
                    </div>
                    <!-- Tótem (solo si la empresa lo tiene activo) -->
                    <div class="channel-card" *ngIf="hasBusinessChannel('Totem')" [class.selected]="isChannelSelected(4)" (click)="toggleChannel(4)">
                        <i class="fal fa-tablet-screen"></i>
                        <span>Tótem</span>
                        <i class="fa-solid fa-circle-check check-icon" *ngIf="isChannelSelected(4)"></i>
                    </div>
                    <!-- App -->
                    <div class="channel-card channel-card--coming-soon">
                        <span class="coming-soon-badge">Próximamente</span>
                        <i class="fal fa-mobile-screen"></i>
                        <span>App</span>
                    </div>
                </div>
            </div>

            <!-- Bulk creation (superadmin only) -->
            <div class="form-card" *ngIf="isSuperAdmin && !isEdit">
                <div class="card-header">
                    <i class="fal fa-layer-group card-icon"></i>
                    <div>
                        <h2>Crear para todas las empresas</h2>
                        <p class="card-subtitle">Solo visible para superadministradores</p>
                    </div>
                </div>
                <mat-checkbox formControlName="all_companies" color="primary">
                    Crear para todas las empresas
                </mat-checkbox>
            </div>
        </div>

        <!-- Right column: Preview -->
        <div class="preview-column">
            <!-- Active toggle -->
            <div class="active-toggle-bar" *ngIf="isEdit" [class.active]="form.get('active')?.value">
                <div class="active-toggle-info">
                    <i class="fal" [ngClass]="form.get('active')?.value ? 'fa-circle-check' : 'fa-circle-xmark'"></i>
                    <div>
                        <span class="active-toggle-label">{{ form.get('active')?.value ? 'Descuento activo' : 'Descuento inactivo' }}</span>
                        <span class="active-toggle-hint">{{ form.get('active')?.value ? 'Los clientes pueden usarlo' : 'No se aplica a nuevas compras' }}</span>
                    </div>
                </div>
                <mat-slide-toggle formControlName="active" color="primary"></mat-slide-toggle>
            </div>

            <div class="preview-card">
                <div class="preview-header">
                    <span class="preview-title"><i class="fal fa-eye"></i> Vista previa</span>
                    <span class="preview-badge" [class.editing]="isEdit">{{ isEdit ? 'Editando' : 'Borrador' }}</span>
                </div>
                <div class="preview-body">
                    <div class="preview-banner">
                        <div class="preview-type-badge">
                            <i class="fal" [ngClass]="form.get('rule_type')?.value === 'promo_code' ? 'fa-ticket-simple' : form.get('rule_type')?.value === 'volume' ? 'fa-users' : 'fa-box-open'"></i>
                            {{ form.get('rule_type')?.value === 'promo_code' ? 'Código' : form.get('rule_type')?.value === 'volume' ? 'Volumen' : 'Pack' }}
                        </div>
                        <div class="preview-code"
                            *ngIf="form.get('rule_type')?.value === 'promo_code' && form.get('promo_code_value')?.value">
                            <i class="fal fa-copy"></i> {{ form.get('promo_code_value')?.value | uppercase }}
                        </div>
                        <div class="preview-headline">
                            {{ form.get('public_name')?.value || form.get('name')?.value || 'Tu promoción' }}
                        </div>
                        <div class="preview-discount-value" *ngIf="form.get('rule_type')?.value !== 'bundle'">
                            -{{ form.get('discount_value')?.value || 0 }}{{ form.get('discount_mode')?.value === 'percentage' ? '%' : '€' }}
                        </div>
                        <div class="preview-discount-value" *ngIf="form.get('rule_type')?.value === 'bundle'">
                            {{ form.get('buy_quantity')?.value || 'X' }}x{{ form.get('pay_quantity')?.value || 'Y' }}
                        </div>
                    </div>
                    <div class="preview-details">
                        <div class="preview-detail-row" *ngIf="form.get('ends_at')?.value">
                            <span><i class="fal fa-calendar"></i> Válido hasta</span>
                            <span class="detail-value">{{ form.get('ends_at')?.value | date:'dd MMM, yyyy' }}</span>
                        </div>
                        <div class="preview-detail-row" *ngIf="!form.get('ends_at')?.value">
                            <span><i class="fal fa-infinity"></i> Vigencia</span>
                            <span class="detail-value">Indefinida</span>
                        </div>
                        <div class="preview-detail-row">
                            <span><i class="fal fa-bullseye"></i> Alcance</span>
                            <span class="detail-value">{{ form.get('apply_scope')?.value === 'company' ? 'Todos los eventos' : getSelectedEvents().length + ' evento' + (getSelectedEvents().length !== 1 ? 's' : '') }}</span>
                        </div>
                        <div class="preview-detail-row" *ngIf="form.get('rule_type')?.value !== 'bundle' && form.get('discount_mode')?.value === 'percentage' && form.get('max_discount_amount')?.value">
                            <span><i class="fal fa-shield"></i> Tope máximo</span>
                            <span class="detail-value">{{ form.get('max_discount_amount')?.value | number:'1.2-2' }}€</span>
                        </div>
                        <div class="preview-detail-row" *ngIf="form.get('rule_type')?.value === 'bundle'">
                            <span><i class="fal fa-box-open"></i> Pack</span>
                            <span class="detail-value">Compra {{ form.get('buy_quantity')?.value || '?' }}, paga {{ form.get('pay_quantity')?.value || '?' }}</span>
                        </div>
                        <div class="preview-detail-row" *ngIf="form.get('rule_type')?.value === 'volume'">
                            <span><i class="fal fa-users"></i> Mínimo</span>
                            <span class="detail-value">{{ form.get('min_quantity')?.value || '?' }} entradas</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Actions -->
            <div class="form-actions">
                <button type="submit" class="btn-save" [disabled]="form.invalid || saving">
                    <i class="fal" [ngClass]="saving ? 'fa-spinner-third fa-spin' : 'fa-floppy-disk'"></i>
                    {{ saving ? 'Guardando...' : (isEdit ? 'Guardar cambios' : 'Crear descuento') }}
                </button>
                <button type="button" class="btn-cancel" (click)="cancel()">
                    Cancelar
                </button>
            </div>
        </div>
    </form>
</div>
